import { render } from "./QuizTest.vue?vue&type=template&id=1e303e16&scoped=true"
import script from "./QuizTest.vue?vue&type=script&lang=js"
export * from "./QuizTest.vue?vue&type=script&lang=js"

import "./QuizTest.vue?vue&type=style&index=0&id=1e303e16&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e303e16"]])

export default __exports__